module.exports = __webpack_public_path__ + "static/img/mz.ef4657da.svg";